export default "__VITE_ASSET__DUG6TAv2__"